import React from "react";
import moment from "moment";
import { RaisedButton } from "material-ui";
import ScheduleWidget from "./schedule-widget.jsx";
import LinkLike from "./link-like.jsx";
import WorkingIndicator from "./working-indicator.jsx";
import DateTimeUtil from "../../utils/DateTimeUtil";

import connectToStores from "alt-utils/lib/connectToStores";
import ReportScheduleStore from "../../stores/ReportScheduleStore";
import ReportScheduleActions from "../../actions/ReportScheduleActions";
import EventStore from "../../stores/EventStore";
import EventActions from "../../actions/EventActions";

class ScheduleTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showNewEditor: false,
      showDeleteItem: null,
      selectedItem: null,
      reportTypes: {
        box_office_report: "Box Office Report by Film",
        custom_ledger_report: "Ledger Transaction Report",
        recurring_pass_renewal_report: "Recurring Pass Renewal Report",
        expired_pass_report: "Expired Pass Report",
        new_subscription_report: "New Subscription Report"
      },
      timeLabels: DateTimeUtil.getTimeListAsObject()
    };

    this.buildTimeLabel = this.buildTimeLabel.bind(this);
    this.makeRowForScheduleItem = this.makeRowForScheduleItem.bind(this);
    this.makeSelectedRow = this.makeSelectedRow.bind(this);
    this.buildReportName = this.buildReportName.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handlePauseResume = this.handlePauseResume.bind(this);
    this.handleDeleteConfirm = this.handleDeleteConfirm.bind(this);
    this.handleDeleteCancel = this.handleDeleteCancel.bind(this);
    this.updateEventList = this.updateEventList.bind(this);
    this.processEvents = this.processEvents.bind(this);
  }

  static getStores() {
    return [ReportScheduleStore, EventStore];
  }

  static getPropsFromStores() {
    return {
      getEventsForEventBucket: EventStore.getEventsForEventBucket,
      getReportScheduleById: ReportScheduleStore.getReportScheduleById,
      getAllUserReportSchedules: ReportScheduleStore.getAllUserReportSchedules,
      isFetching: ReportScheduleStore.getState().isFetching
    };
  }

  componentDidMount() {
    ReportScheduleActions.fetchAllForUser.defer();
  }

  updateEventList(bucketId) {
    this.setState({ selectedBucket: bucketId }, () => {
      EventActions.fetchAllForBucket(bucketId);
    });
  }

  getStyles() {
    return {
      scheduleTable: {},
      gridHeader: {
        backgroundColor: "#1c94d6",
        color: "#fff",
        fontWeight: "bold"
      },
      actionColumn: {
        whiteSpace: "nowrap",
        overflowX: "visible"
      },
      actionLink: {
        float: "left",
        marginRight: "15px"
      }
    };
  }

  capitalize(value) {
    if (typeof value !== "string") return "";
    return value.charAt(0).toUpperCase() + value.slice(1);
  }

  buildTimeLabel(item) {
    let bucket;
    if (item.event_bucket && item.event_bucket.length) {
      bucket = this.props.buckets.find(
        element => element.id === item.event_bucket[0]._id
      );
    }
    if (bucket) {
      const hourNum = item.time.substring(0, item.time.indexOf(":"));
      const selectedTime = moment()
        .utc()
        .set("hour", parseInt(hourNum, 10))
        .tz(bucket.timezone)
        .format("HH:00");
      return (
        this.state.timeLabels[selectedTime] +
        " " +
        moment.tz(bucket.timezone).format("z")
      );
    } else {
      return "";
    }
  }

  handlePauseResume(item) {
    item.active = !item.active;
    item.event_bucket = item.event_bucket.map(e => {
      if (e._id) {
        return e._id;
      } else {
        return e;
      }
    });
    item.films = item.films ? item.films : item.film ? [item.film] : [];
    ReportScheduleActions.update(item);
  }

  handleClose() {
    this.setState({ selectedItem: null, showNewEditor: false });
  }

  handleUpdate(values) {
    let updatedItem = {
      report_name: values.report_name,
      event_bucket: values.event_bucket,
      films: values.films ? values.films : [],
      conditions: values.conditions ? values.conditions : {},
      nickname: values.nickname ? values.nickname : "",
      time: values.time.value,
      day_of_week: values.day_of_week ? values.day_of_week.value : null,
      frequency: values.frequency.value,
      recipient_emails: values.recipient_emails
    };

    if (this.state.showNewEditor) {
      this.setState({ selectedItem: null, showNewEditor: false });
      ReportScheduleActions.create(updatedItem);
    } else {
      this.setState({ selectedItem: null });
      updatedItem.id = values.id;
      ReportScheduleActions.update(updatedItem);
    }
  }

  handleDeleteConfirm() {
    ReportScheduleActions.delete(this.state.showDeleteItem);
    this.setState({ selectedItem: null, showDeleteItem: null });
  }

  handleDeleteCancel() {
    this.setState({ selectedItem: null, showDeleteItem: null });
  }

  processEvents() {
    let events = null;
    const unprocessedEvents = this.props.getEventsForEventBucket(
      this.state.selectedBucket
    );
    events = unprocessedEvents.map(e => {
      return {
        label: e.name,
        value: e.id,
        id: e.id
      };
    });
    return events;
  }

  makeSelectedRow(item) {
    const styles = this.getStyles();
    const reportName = this.buildReportName(item);
    const events = this.processEvents();

    return [
      <tr key={item.id}>
        <td>{reportName}</td>
        <td width="100">{this.capitalize(item.frequency)}</td>
        <td width="120">{this.buildTimeLabel(item)}</td>
        <td width="100">
          {item.last_sent_status
            ? this.capitalize(item.last_sent_status)
            : "Scheduled"}
        </td>
        <td width="160" style={styles.actionColumn}></td>
      </tr>,

      <tr key={item.id + "_edit"}>
        <td colSpan={5}>
          <ScheduleWidget
            item={item}
            update={this.handleUpdate}
            close={this.handleClose}
            buckets={this.props.buckets}
            films={this.props.films}
            events={events}
            updateEvents={this.updateEventList}
          />
        </td>
      </tr>
    ];
  }

  makeRowForDeleteItem(item) {
    const styles = this.getStyles();
    const reportName = this.buildReportName(item);
    return [
      <tr key={item.id} style={{ backgroundColor: "#ffcccb" }}>
        <td style={{ paddingTop: "15px" }}>{reportName}</td>
        <td width="100">{this.capitalize(item.frequency)}</td>
        <td width="120">{this.buildTimeLabel(item)}</td>
        <td width="100">
          {item.last_sent_status
            ? this.capitalize(item.last_sent_status)
            : "Scheduled"}
        </td>
        <td width="160" style={styles.actionColumn}></td>
      </tr>,

      <tr key={item.id + "_delete"}>
        <td
          colSpan={5}
          style={{
            textAlign: "right",
            fontWeight: "bold",
            paddingBottom: "20px",
            backgroundColor: "#ffcccb"
          }}
        >
          <div style={{ paddingBottom: "5px" }}>
            Are you sure you want to delete this schedule?
          </div>
          <RaisedButton
            label="Delete"
            backgroundColor="#f00"
            labelColor="#fff"
            onTouchTap={this.handleDeleteConfirm}
          />
          <RaisedButton
            label="Never Mind"
            primary={false}
            style={{ marginLeft: "15px" }}
            onTouchTap={this.handleDeleteCancel}
          />
        </td>
      </tr>
    ];
  }

  makeRowForScheduleItem(item) {
    const styles = this.getStyles();
    const reportName = this.buildReportName(item);
    return [
      <tr
        key={item.id}
        className="schedule-report-row"
        style={item.active ? {} : { color: "#bbb" }}
      >
        <td>{reportName}</td>
        <td width="100">{this.capitalize(item.frequency)}</td>
        <td width="120">{this.buildTimeLabel(item)}</td>
        <td width="100">
          {item.last_sent_status
            ? this.capitalize(item.last_sent_status)
            : "Scheduled"}
        </td>
        <td width="160" style={styles.actionColumn}>
          <LinkLike
            style={styles.actionLink}
            onTouchTap={e => {
              this.handlePauseResume(item);
            }}
          >
            {item.active ? "Pause" : "Resume"}
          </LinkLike>
          <LinkLike
            style={styles.actionLink}
            onTouchTap={e => {
              this.setState({ showNewEditor: false, selectedItem: item.id });
            }}
          >
            Edit
          </LinkLike>
          <LinkLike
            style={styles.actionLink}
            onTouchTap={e => {
              this.setState({
                showNewEditor: false,
                selectedItem: item.id,
                showDeleteItem: item.id
              });
            }}
          >
            Delete
          </LinkLike>
        </td>
      </tr>
    ];
  }

  buildReportName(item) {
    let reportName = this.state.reportTypes[item.report_name];
    const hasSingleFilm = typeof item.film !== "undefined";
    const multipleFilmsName = item.films && item.films.length === 1
      ? item.films[0].name
      : "Films"
    const singleFilmName = !item.film ? "Unnamed Film" : item.film.name
    if (item.report_name === "box_office_report") {
      reportName =
        reportName +
        " - " +
        (hasSingleFilm
          ? singleFilmName
          : multipleFilmsName);
      //} else if (item.report_name === "memberbership_renewal_report") {
      //    reportName = reportName;
    } else if (item.nickname && item.nickname !== "") {
      reportName = reportName + " - " + item.nickname;
    }
    return reportName;
  }

  render() {
    let styles = this.getStyles();

    const items = this.props.getAllUserReportSchedules();

    if (this.props.isFetching && items.length === 0) {
      return <WorkingIndicator fullPage={true} />;
    }

    const events = this.processEvents();

    return (
      <div>
        <div style={{ paddingTop: "10px" }}>
          <table>
            <thead style={styles.gridHeader}>
              <td>Name</td>
              <td>Frequency</td>
              <td>Time</td>
              <td>Status</td>
              <td>Actions</td>
            </thead>
            <tbody>
              {items
                ? items.map(item => {
                    return this.state.selectedItem === item.id
                      ? this.state.showDeleteItem === item.id
                        ? this.makeRowForDeleteItem(item)
                        : this.makeSelectedRow(item)
                      : this.makeRowForScheduleItem(item);
                  })
                : null}
            </tbody>
          </table>
        </div>
        {items.length === 0 ? (
          <div className="empty-table-message">
            No scheduled reports yet.{" "}
            <LinkLike
              onTouchTap={() =>
                this.setState({
                  selectedItem: null,
                  showNewEditor: true
                })
              }
            >
              Schedule an automated report.
            </LinkLike>
          </div>
        ) : null}
        {this.state.showNewEditor ? null : (
          <div style={{ marginTop: "1em" }}>
            <RaisedButton
              label="Create new Scheduled Report"
              primary={true}
              onClick={() =>
                this.setState({ selectedItem: null, showNewEditor: true })
              }
            />
          </div>
        )}
        {this.state.showNewEditor ? (
          <div style={{ paddingTop: 10 }}>
            <ScheduleWidget
              item={{}}
              update={this.handleUpdate}
              close={this.handleClose}
              buckets={this.props.buckets}
              films={this.props.films}
              events={events}
              updateEvents={this.updateEventList}
              isNew
            />
          </div>
        ) : null}
      </div>
    );
  }
}

export default connectToStores(ScheduleTable);



// WEBPACK FOOTER //
// ./src/app/components/partials/schedule-table.jsx